import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { Box, Typography, IconButton, Button, Tooltip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import FmdBadOutlinedIcon from '@mui/icons-material/FmdBadOutlined';
import incomingCallGif from '../../../assets/images/incomingCall.gif';
import IncomingCallDetails from './IncomingCallDetails';

const IncomingCallContent = function IncomingCallContent({
  customerData = {},
  onClose = () => {},
  onClick = () => {},
}) {
  const intl = useIntl();
  const [expanded, setExpanded] = useState(false);

  const handleToggleExpandContent = () => {
    setExpanded(!expanded);
  };

  return (
    <div style={{ width: '100%', color: '#fff', borderRadius: '10px' }}>
      <Box
        sx={{
          display: 'flex',
          width: '350px',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '8px',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            minWidth: 0,
          }}
        >
          <img src={incomingCallGif} alt="gif" width="50px" height="50px" />
          <Box sx={{ minWidth: 0 }}>
            <Typography
              variant="caption"
              sx={{ display: 'block', opacity: 0.8, lineHeight: 1.2 }}
            >
              {intl.messages.INBOUND_CALL}
            </Typography>
            <Typography variant="body1" noWrap sx={{ fontWeight: 600 }}>
              {customerData?.entityFullName || intl.messages.UNAVAILABLE}
            </Typography>
          </Box>
          {customerData?.assignedBranchId &&
          customerData?.assignedBranchId !== customerData?.branchId ? (
            <Tooltip
              title={`${intl.messages.ASSIGNEDBRANCH}: ${customerData?.assignedBranch}`}
              placement="top"
              arrow
              slotProps={{
                tooltip: { sx: { fontSize: '1rem', padding: '8px' } },
              }}
            >
              <FmdBadOutlinedIcon color="warning" sx={{ flexShrink: 0 }} />
            </Tooltip>
          ) : null}
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
          <Button
            sx={{
              display: expanded && 'none',
              color: 'white.main',
              borderColor: 'white.main',
            }} //hide when details is expanded
            variant="text"
            onClick={handleToggleExpandContent}
          >
            {intl.messages.DETAILS}
          </Button>
          <IconButton onClick={onClose} color="inherit" size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </Box>
      <IncomingCallDetails
        show={expanded}
        customerData={customerData}
        goToCustomerPage={onClick}
      />
    </div>
  );
};

export default IncomingCallContent;
